import { format, isThisYear } from 'date-fns';
import { fr } from 'date-fns/locale';

/**
 * Figma's short date ("Since Aug 5", "Completed on Aug 16"); French puts the day first ("5 août").
 * Judgement call (Figma and spec silent): the year is added when the date isn't in the current year,
 * since "Aug 5" alone would then read as this year.
 */
export default function formatShortDate(date: Date, language: string) {
  const sameYear = isThisYear(date);

  if (language.startsWith('fr')) return format(date, sameYear ? 'd MMM' : 'd MMM yyyy', { locale: fr });

  return format(date, sameYear ? 'MMM d' : 'MMM d, yyyy');
}
